import React, { Component } from "react";
import { PiShield, PiBriefcase, PiBuildings, PiMapPin, PiEye } from "react-icons/pi";
import { getAvatarInitials, getFullname } from "../evs-utils";
import { Badge } from "react-bootstrap";
import "../evs.css";
// Helper: use "-" when value is missing
const orDash = (v) => (v != null && String(v).trim() !== "" ? String(v).trim() : "-");
// 7 colors for the 7 risk dots
const RISK_DOT_COLORS = ["#FEE9E9", "#FFCCCC", "#FFAAAA", "#FF9494", "#FF6868", "#FF4141", "#842323"];
export default class EVStable extends Component {
	render() {
		const evs = this.props.evs;
		const target = evs?.target || {};
		const score = parseInt(evs?.percent, 10) || 0;
		const fullname = getFullname(target.firstname, target.lastname);
		const avatarInitial = getAvatarInitials(target.firstname, target.lastname);
		const vulnerabilityLevel = orDash(evs?.vulnerabilityLevel);
		const vulnerabilityLevelKey = String(evs?.vulnerabilityLevel || "").trim().toLowerCase();
		// 7 dots: filled count from percentage (0–7)
		const filledDots = Math.min(7, Math.round((score / 100) * 7));
		const isDisabled = target.email === "User not found";

		return (
			<div className={`evs-table-card ${isDisabled ? "evs-table-card--disabled" : ""}`}>
				{/* Avatar + Name & Email */}
				<div className="evs-table-card__user"
					onClick={() => !isDisabled && this.props.onViewEvs && this.props.onViewEvs(evs)}>
					<div
						className="evs-table-card__avatar"
					>
						<span className={isDisabled ? "blur-text" : ""}>{avatarInitial}</span>
					</div>
					<div className="evs-table-card__user-info">
						<div className={`evs-table-card__name ${isDisabled ? "blur-text" : ""}`}>
							{orDash(fullname)}
						</div>
						<div className="evs-table-card__email">
							{orDash(target.email)}
						</div>
					</div>
				</div>

				

				{/* Job Title */}
				<div className="evs-table-card__meta evs-table-card__meta--job">
					<PiBriefcase className="evs-table-card__meta-icon" />
					<span className="evs-table-card__meta-text">{orDash(target.designation?.name)}</span>
				</div>

				{/* Team */}
				<div className="evs-table-card__meta evs-table-card__meta--team">
					<PiBuildings className="evs-table-card__meta-icon" />
					<span className="evs-table-card__meta-text">{orDash(target.department?.name)}</span>
				</div>

				{/* Location */}
				<div className="evs-table-card__meta evs-table-card__meta--location">
					<PiMapPin className="evs-table-card__meta-icon" />
					<span className="evs-table-card__meta-text">{orDash(target.location?.name)}</span>
				</div>

				{/* Risk / Progress: shield + 10 dots */}
				<div className="evs-table-card__risk">
				<Badge
					variant="danger"
					className={`evs-table-card__risk-level ${vulnerabilityLevelKey ? `evs-risk-distribution__segment--${vulnerabilityLevelKey}` : ""}`}
				>
					{vulnerabilityLevel}
				</Badge>	
					<PiShield className="evs-table-card__risk-icon" />
					<div className="evs-table-card__risk-dots">
						{score > 0 && Array.from({ length: 7 }, (_, i) => (
							<span
								key={i}
								className={`evs-table-card__risk-dot ${i < filledDots ? "evs-table-card__risk-dot--filled" : ""}`}
								style={i < filledDots ? { backgroundColor: RISK_DOT_COLORS[i] } : undefined}
							/>
						))}
					</div>
					<span className="evs-table-card__risk-pct">
						{evs.percent != null && evs.percent !== "" ? Number(evs.percent) + "%" : "-"}
					</span>
				</div>

				{/* Actions: View (opens drawer), Download */}
				<div className="evs-table-card__actions">
					<button
						type="button"
						className="evs-table-card__action-btn"
						title="View"
						disabled={isDisabled}
						onClick={() => !isDisabled && this.props.onViewEvs && this.props.onViewEvs(evs)}
					>
						<PiEye />
					</button>
				</div>
			</div>
		);
	}
}
